import 'reflect-metadata';
import {
  Expose,
  plainToInstance,
  instanceToPlain,
  Type,
} from 'class-transformer';

export class UserKyc {
  id: number;

  status: string;

  @Expose({ name: 'category_name' })
  categoryName: string;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  dateCreated: Date;

  documents: string[];

  constructor(
    id: number,
    status: string,
    categoryName: string,
    dateCreated: Date,
    documents: string[]
  ) {
    this.id = id;
    this.status = status;
    this.categoryName = categoryName;
    this.dateCreated = dateCreated;
    this.documents = documents;
  }

  static fromJson(json: Record<string, any>): UserKyc {
    return plainToInstance(UserKyc, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
